module.exports = __webpack_public_path__ + "static/media/circle-cross.91bb38d0.svg";